import { IconProps } from 'utils/global.types';

export const Edit = (props?: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 12 12" {...props}>
    <path
      fill="#fff"
      d="M6.138 3.602l-3.92 3.925a.909.909 0 00-.258.538L1.804 9.44a.692.692 0 00.689.763h.08l1.371-.157a.92.92 0 00.537-.255L8.4 5.86 6.138 3.602zM9.925 3.114L8.886 2.076a.935.935 0 00-1.324 0l-.962.962 2.362 2.363.963-.963a.935.935 0 000-1.324z"
    ></path>
  </svg>
);
